// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2F-LW","search":"Settings_search__1MPrn","filter":"Settings_filter__OMLjU"};